import apiClient from './apiClient';

/**
 * Formula Registry client (FEAT "Formula Registry", 2026-07-15).
 *
 * The calculation-tooltip text on every test-result table header is served by
 * the backend registry (`GET /api/test-formulas`), so the frontend column
 * configs no longer transcribe formula strings by hand. Values are the internal
 * `verify`-guarded truth, minus the golden.
 */
export interface PublicFormulaEntry {
  /** Stable key matching the grid column's `columnKey` (NOT the display label). */
  columnKey: string;
  label: string;
  kind: 'calc' | 'raw';
  formula?: string;
  note?: string;
}

/** Response shape: keyed by test-type id (`directShear`, `triaxial`, …). */
export type TestFormulasResponse = Record<string, PublicFormulaEntry[]>;

/** Fetch the formula entries for ONE test type. Returns [] when unknown. */
export async function fetchTestFormulas(testTypeId: string): Promise<PublicFormulaEntry[]> {
  const res = await apiClient.get<TestFormulasResponse>('/test-formulas', {
    params: { testType: testTypeId },
  });
  return res.data?.[testTypeId] ?? [];
}
